/** Work history + projects sourced from Akash Sharma resume */

export const summary =
  "Full-stack engineer with 5+ years shipping production web products — deepest expertise on the frontend (React, Next.js, TypeScript). Proven impact on load time (−30%), engagement (+20%), and partner ROAS (+15%).";

export const experience = [
  {
    company: "Helium",
    location: "Delhi, India",
    title: "Software Engineer (Full-Stack / Frontend-heavy)",
    period: "May 2024 — Present",
    points: [
      "Spearheaded a drag-and-drop website builder in Next.js, Puck, and Nx — design, preview, and publish for non-technical users.",
      "Built high-performance brand landing pages (App Router, ISR, image optimization); ~30% faster load and ~20% higher engagement.",
      "Shipped partner brand experiences for Noise, Leaf Studios, and Honasa brands FIKN + Lumineve (Mamaearth house of brands).",
      "Architected Impulse analytics (Next.js, React Query, GraphQL), contributing to ~15% ROAS lift for partner brands.",
      "Drove self-serve onboarding UX and frontend A/B experiments; partnered on Bun/Elysia + GraphQL API work.",
    ],
    projects: [
      "Helium website builder",
      "Noise PDPs (gonoise.com)",
      "FIKN · Lumineve · Leaf Studios",
      "Impulse Analytics",
    ],
    tags: [
      "Next.js",
      "TypeScript",
      "GraphQL",
      "React Query",
      "Nx",
      "Bun",
      "PostgreSQL",
    ],
  },
  {
    company: "Vaionex Corporation",
    location: "Noida, India",
    title: "Front-End / Full-Stack Developer",
    period: "Sep 2023 — May 2024",
    points: [
      "Shipped AI-powered web UIs with GPT and ComfyUI Stable Diffusion; up to ~90% page-load improvement via bundle and image streaming work.",
      "Built reusable React component libraries and design tokens across product launches.",
      "Developed interactive D3.js visualizations on Memgraph for large knowledge-graph exploration.",
      "Partnered with design and PM to ship Figma-to-production, accessible UIs.",
    ],
    projects: [
      "AI generation interfaces (GPT + Stable Diffusion)",
      "Knowledge-graph explorer (D3 + Memgraph)",
      "Shared React design system",
    ],
    tags: [
      "Next.js",
      "React",
      "TypeScript",
      "D3.js",
      "Firebase",
      "AWS",
      "OpenAI",
    ],
  },
  {
    company: "Cloudstok",
    location: "Noida, India",
    title: "Software Development Engineer",
    period: "Feb 2021 — Sep 2023",
    points: [
      "Delivered end-to-end web and mobile solutions for 12 client projects using React, Next.js, Gatsby, React Native, and Node.js.",
      "Led a team of 6 engineers — sprint planning, code reviews, and frontend architecture across parallel deliveries.",
      "Built internal tooling and admin dashboards that boosted operational efficiency by ~70%.",
      "Introduced Jest/RTL coverage and CI practices that reduced UI regressions in production.",
    ],
    projects: [
      "12+ client web & mobile deliveries",
      "Internal admin dashboards",
      "Team leadership (6 engineers)",
    ],
    tags: [
      "React",
      "Next.js",
      "React Native",
      "Node.js",
      "GraphQL",
      "AWS",
      "MongoDB",
    ],
  },
];

export const resumeProjects = [
  {
    title: "BPLaw Full-Stack Legal Platform",
    description:
      "Next.js + Node/Firebase platform with marketing site, authenticated admin flows, and payment-ready checkout for a law-consulting firm.",
    link: "https://github.com/aakashsh1999/Law-firm-site",
    tech: ["Next.js", "Firebase", "Node.js"],
  },
  {
    title: "Professional Networking App",
    description:
      "LinkedIn-style cross-platform experience with React Native, Node.js, and Supabase — real-time messaging and feed ranking.",
    link: null,
    tech: ["React Native", "Node.js", "Supabase"],
  },
  {
    title: "Meradoc Healthcare Platform",
    description:
      "Cross-platform telehealth UI with React Native; video consultations via Twilio/100ms; focused on crash reduction and stable releases.",
    link: "https://www.meradoc.com",
    tech: ["React Native", "100ms", "Firebase"],
  },
];

export const education = {
  degree: "Bachelor of Computer Application (BCA)",
  school: "IGNOU, New Delhi",
  period: "Jan 2018 — Jun 2022",
};
